require('angular')
    .module('wowApp.shop')
    .service('StoreService', ['Restangular', 'StoreFilterService', 'LocationService', require('./store.service')])
    .service('StoreFilterService', [require('./store-filter.service')]);



// WEBPACK FOOTER //
// ./src/shop/stores/index.js